// extracted by mini-css-extract-plugin
export default {"settings_container":"settings_container__OfgCX","contentContainer":"contentContainer__srj7t"};